// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__pDpOy","filters_close":"FiltersBlock_filters_close__Kjnmz"};